import { ChangeDetectionStrategy, Component, ViewChild, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { WatchlistAddTickerDialogComponent } from '../../../../features/watchlist/dialogs/add-ticker-dialog/watchlist-add-ticker-dialog.component';

@Component({
  selector: 'app-watchlist-add-icon-button',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    WatchlistAddTickerDialogComponent
  ],
  templateUrl: './watchlist-add-icon-button.component.html',
  styleUrls: ['./watchlist-add-icon-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WatchlistAddIconButtonComponent {
  @ViewChild(WatchlistAddTickerDialogComponent)
  addTickerDialog?: WatchlistAddTickerDialogComponent;

  // Input
  ticker = input.required<string>();

  /**
   * Open the add ticker to watchlist dialog
   */
  openAddDialog(): void {
    this.addTickerDialog?.show(this.ticker());
  }
}
